import { createTheme } from '@mui/material/styles';
import { fallbackPalette } from './fallbackPalette';
import { breakpoints, customPalette, customTypography } from './overrides';

// Create a minimal theme, this will only be used when a fatal error occurs
export const fallbackTheme = createTheme({
  breakpoints,
  typography: customTypography.typography,
  palette: customPalette(fallbackPalette),
  components: { MuiCssBaseline: { styleOverrides: `html, body, #root  { height: 100% }` } },
  custom: {
    spacing: {
      xxs: 0.5,
      xs: 1,
      sm: 1.5,
      md: 2,
      lg: 3,
      xl: 4,
      '2xl': 5,
      '3xl': 6,
      '4xl': 8,
      '5xl': 10,
      '6xl': 12,
      '7xl': 16,
      '8xl': 20,
      '9xl': 24,
      '10xl': 32,
      '11xl': 40,
    },
    radius: {
      xxs: 0.5,
      xs: 1,
      sm: 1.5,
      md: 2,
      lg: 2.5,
      xl: 3,
      '2xl': 4,
      '3xl': 5,
      '4xl': 6,
      full: 9999,
    },
    width: {
      xxs: 60,
      xs: 72,
      sm: 90,
      md: 105,
      lg: 120,
      xl: 144,
      '2xl': 192,
      '3xl': 240,
      '4xl': 270,
      '5xl': 300,
      '6xl': 360,
    },
  },
});
